import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { ContentState } from 'draft-js';
import { List, OrderedSet } from 'immutable';
import isEqual from 'lodash/isEqual';
import { BlockType } from '@uno/common-cms';
import { mapAsync } from '@uno/common-shared';
import { toFlatContentBlocks } from './blockConfigManagement';
import { detectBlockType } from './blockDetection';
import { addLinkEntity, isLink } from './linkEntity';
import { sanitizeHTML } from './sanitizeHtml';
import { detectStyle } from './styleDetection';
import { convertTextNodeToTextState, mergeTextStates } from './textExtraction';
var blockIdToIncrement = 0;
var EMPTY_TEXT_STATE = {
  text: '',
  characterList: []
};
export var processChildNodes = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
    var siteId, nodes, currentProcessedNode, _ref$currentEntity, currentEntity, _ref$currentStyle, currentStyle, processedChildNodes;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            siteId = _ref.siteId, nodes = _ref.nodes, currentProcessedNode = _ref.currentProcessedNode, _ref$currentEntity = _ref.currentEntity, currentEntity = _ref$currentEntity === void 0 ? null : _ref$currentEntity, _ref$currentStyle = _ref.currentStyle, currentStyle = _ref$currentStyle === void 0 ? OrderedSet() : _ref$currentStyle;
            _context2.next = 3;
            return mapAsync(Array.from(nodes), /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(node) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return processNode({
                          siteId: siteId,
                          node: node,
                          currentProcessedNode: currentProcessedNode,
                          currentEntity: currentEntity,
                          currentStyle: currentStyle
                        });

                      case 2:
                        return _context.abrupt("return", _context.sent);

                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref3.apply(this, arguments);
              };
            }());

          case 3:
            processedChildNodes = _context2.sent;
            return _context2.abrupt("return", {
              textState: mergeTextStates(processedChildNodes),
              blockConfigs: processedChildNodes.flatMap(function (processedChildNode) {
                return processedChildNode.blockConfigs;
              }),
              contentState: currentProcessedNode.contentState
            });

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function processChildNodes(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/** Recursive function which dives through the tree and builds block configs */

var processNode = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
    var _detectBlockType;

    var siteId, node, currentProcessedNode, _ref4$currentEntity, currentEntity, _ref4$currentStyle, currentStyle, textState, blockConfigs, contentState, nodeName, blockType, key, _yield$processChildNo, newTextState, childConfigs, block, newStyle;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            siteId = _ref4.siteId, node = _ref4.node, currentProcessedNode = _ref4.currentProcessedNode, _ref4$currentEntity = _ref4.currentEntity, currentEntity = _ref4$currentEntity === void 0 ? null : _ref4$currentEntity, _ref4$currentStyle = _ref4.currentStyle, currentStyle = _ref4$currentStyle === void 0 ? OrderedSet() : _ref4$currentStyle;
            textState = currentProcessedNode.textState, blockConfigs = currentProcessedNode.blockConfigs, contentState = currentProcessedNode.contentState;
            nodeName = node.nodeName.toLowerCase(); // Case 1: node is a block node
            // TODO: handle nodes multiple possible BlockType, like list items (li tag)

            blockType = (_detectBlockType = detectBlockType(nodeName)) === null || _detectBlockType === void 0 ? void 0 : _detectBlockType[0];

            if (!(blockType !== undefined)) {
              _context3.next = 13;
              break;
            }

            key = "key".concat(blockIdToIncrement++); // Compute child nodes

            _context3.next = 8;
            return processChildNodes({
              siteId: siteId,
              nodes: node.childNodes,
              currentProcessedNode: {
                textState: textState,
                blockConfigs: blockConfigs,
                contentState: contentState
              },
              currentEntity: currentEntity,
              currentStyle: currentStyle
            });

          case 8:
            _yield$processChildNo = _context3.sent;
            newTextState = _yield$processChildNo.textState;
            childConfigs = _yield$processChildNo.blockConfigs;
            // Create a block config
            block = {
              key: key,
              type: blockType,
              text: newTextState.text,
              characterList: newTextState.characterList,
              depth: 0,
              children: List(),
              childConfigs: childConfigs
            };
            return _context3.abrupt("return", {
              textState: EMPTY_TEXT_STATE,
              blockConfigs: blockConfigs.concat([block]),
              contentState: contentState
            });

          case 13:
            if (!(nodeName === '#text')) {
              _context3.next = 15;
              break;
            }

            return _context3.abrupt("return", {
              textState: convertTextNodeToTextState(node, textState, currentEntity, currentStyle),
              blockConfigs: blockConfigs,
              contentState: contentState
            });

          case 15:
            if (!isLink(node)) {
              _context3.next = 19;
              break;
            }

            _context3.next = 18;
            return addLinkEntity(siteId, node, {
              textState: textState,
              blockConfigs: blockConfigs,
              contentState: contentState
            });

          case 18:
            return _context3.abrupt("return", _context3.sent);

          case 19:
            // Style and not-handled nodes
            newStyle = detectStyle(node);
            _context3.next = 22;
            return processChildNodes({
              siteId: siteId,
              nodes: node.childNodes,
              currentProcessedNode: {
                textState: textState,
                blockConfigs: blockConfigs,
                contentState: contentState
              },
              currentEntity: currentEntity,
              currentStyle: newStyle
            });

          case 22:
            return _context3.abrupt("return", _context3.sent);

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function processNode(_x3) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Converts an HTML string to an array of ContentBlocks and an EntityMap
 * suitable to initialize the internal state of a Draftjs component.
 */


var convertFromHTMLToContentBlocks = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(siteId, htmlOrText) {
    var safeBody, _yield$processNode, textState, blockConfigs, contentState, contentBlocks;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // Sanitize, remove special characters from the HTML string and covert it to a node
            safeBody = sanitizeHTML(htmlOrText);

            if (!(safeBody === null)) {
              _context4.next = 3;
              break;
            }

            return _context4.abrupt("return", null);

          case 3:
            _context4.next = 5;
            return processNode({
              siteId: siteId,
              node: safeBody,
              currentProcessedNode: {
                textState: EMPTY_TEXT_STATE,
                blockConfigs: [],
                contentState: ContentState.createFromText('')
              }
            });

          case 5:
            _yield$processNode = _context4.sent;
            textState = _yield$processNode.textState;
            blockConfigs = _yield$processNode.blockConfigs;
            contentState = _yield$processNode.contentState;

            // In case some text has no block above it, create a block
            if (!isEqual(textState, EMPTY_TEXT_STATE)) {
              blockConfigs.push({
                key: "key".concat(blockIdToIncrement++),
                type: BlockType.UNSTYLED,
                text: textState.text,
                characterList: textState.characterList,
                depth: 0,
                children: List(),
                childConfigs: []
              });
            }

            contentBlocks = toFlatContentBlocks(blockConfigs);
            return _context4.abrupt("return", {
              contentBlocks: contentBlocks,
              entityMap: contentState.getEntityMap()
            });

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function convertFromHTMLToContentBlocks(_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();

export default convertFromHTMLToContentBlocks;